module.exports = __webpack_public_path__ + "img/Icon-Cancel-grey.e091057e.svg";